import React, { MouseEventHandler } from "react";
import styled from "styled-components";
import NavMenuSmallScreen from "./NavMenuSmallScreen";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";

type MainNavigationSmallScreenProps = {
  showMenu: boolean;
  navItemClickHandle: () => void;
  menuShowClickHandle: MouseEventHandler<HTMLButtonElement>;
};

const MainNavigationSmallScreen = ({
  showMenu,
  navItemClickHandle,
  menuShowClickHandle,
}: MainNavigationSmallScreenProps) => {
  return (
    <Wrapper>
      <NavMenuSmallScreen
        showMenu={showMenu}
        navItemClickHandle={navItemClickHandle}
        menuShowClickHandle={menuShowClickHandle}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: none;
  }
`;

export default MainNavigationSmallScreen;
